import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, HStack, Text } from '@rtkwlf/fenrir-react';
import { faTimes } from '@rtkwlf/pro-solid-svg-icons/faTimes';
import { useFormContext, useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { AddIpRangeForm } from '../../add-ip-range-form/add-ip-range-form';
import { DeleteConfirmationDialog } from '../../delete-confirmation-dialog/delete-confirmation-dialog';

type Props = {
  indexOfRowsToDelete: number[];
  resetRowSelection: () => void;
};

export const TableActionRow = ({
  indexOfRowsToDelete,
  resetRowSelection,
}: Props) => {
  const { t } = useTranslation('telemetryScannerConfig');

  const { control } = useFormContext<AddIpRangeForm>();

  const { remove } = useFieldArray({
    control,
    name: 'scanExclusions',
  });

  const handleBulkDelete = () => {
    remove(indexOfRowsToDelete);
    resetRowSelection();
  };

  return (
    <HStack
      width="full"
      marginY="default"
      backgroundColor="widgetSecondary"
      padding="default"
      borderRadius="default"
    >
      <Text>{t('selectedRows', { n: indexOfRowsToDelete.length })}</Text>
      <DeleteConfirmationDialog
        variant="primary"
        actionOnClick={handleBulkDelete}
      />
      <Button
        variant="tertiary"
        iconLeft={<FontAwesomeIcon icon={faTimes} />}
        marginLeft="auto"
        onClick={() => resetRowSelection()}
      >
        {t('actions.deselectAll')}
      </Button>
    </HStack>
  );
};
